"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { cn } from "~/lib/utils";
import { SidebarWidget } from "./SidebarWidget";

// In-article table of contents with scroll-spy. Headings come from
// `extractHeadings` (server) and match the ids the MDX h2 component injects.
// `scrollSpy={false}` for the static mobile copy: it sits above the body rather
// than tracking beside it, so an active highlight would only mislead.
export function BlogToc(t0) {
  const $ = _c(13);
  const {
    headings,
    scrollSpy: t1
  } = t0;
  const scrollSpy = t1 === undefined ? true : t1;
  const [activeId, setActiveId] = useState("");
  let t2;
  let t3;
  if ($[0] !== headings || $[1] !== scrollSpy) {
    t2 = () => {
      if (!scrollSpy) {
        return;
      }
      const els = headings.map(_temp).filter(_temp2);
      if (els.length === 0) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(_temp3).sort(_temp4);
        if (visible[0]) {
          setActiveId(visible[0].target.id);
        }
      }, {
        rootMargin: "-120px 0px -66% 0px"
      });
      for (const el_0 of els) {
        observer.observe(el_0);
      }
      return () => observer.disconnect();
    };
    t3 = [headings, scrollSpy];
    $[0] = headings;
    $[1] = scrollSpy;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (headings.length === 0) {
    return null;
  }
  let t4;
  if ($[4] !== activeId || $[5] !== headings || $[6] !== scrollSpy) {
    let t5;
    if ($[8] !== activeId || $[9] !== scrollSpy) {
      t5 = (h_0, i) => <li key={h_0.id}><a href={`#${h_0.id}`} className={cn("flex items-baseline gap-2.5 border-l-2 border-transparent px-3 py-1.5 text-[13px] font-medium text-secondary transition-colors hover:border-(--blue) hover:bg-bg hover:text-accent", scrollSpy && activeId === h_0.id && "border-(--blue) bg-(--blue-xpale) font-semibold text-accent")}><span className="text-[10px] font-bold text-(--ink-40) tabular-nums">{String(i + 1).padStart(2, "0")}</span>{h_0.text}</a></li>;
      $[8] = activeId;
      $[9] = scrollSpy;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = headings.map(t5);
    $[4] = activeId;
    $[5] = headings;
    $[6] = scrollSpy;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <SidebarWidget title="In this article"><nav aria-label="In this article" className="py-3"><ol>{t4}</ol></nav></SidebarWidget>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp4(a, b) {
  return a.boundingClientRect.top - b.boundingClientRect.top;
}
function _temp3(e) {
  return e.isIntersecting;
}
function _temp2(el) {
  return el !== null;
}
function _temp(h) {
  return document.getElementById(h.id);
}